import cardAuthClient from './cardAuthClient'

// 新服务登录接口地址。
const LOGIN_ENDPOINT = '/auth/login'
// 新服务退出登录接口地址。
const LOGOUT_ENDPOINT = '/auth/logout'
// 登录时默认上送的设备标识。
const DEFAULT_DEVICE_NAME = 'vue2-web'

// 统一提取 axios 响应中的业务数据。
function unwrapResponse(response) {
  return response && response.data ? response.data : response
}

// 统一组装登录请求体。
function buildLoginPayload(payload = {}) {
  return {
    user_name: payload.userName || payload.user_name || '',
    password: payload.password || '',
    device_name: payload.deviceName || payload.device_name || DEFAULT_DEVICE_NAME
  }
}

// 调用新服务登录接口，并在成功后返回最新 cookie 信息。
function login(payload = {}) {
  const requestBody = buildLoginPayload(payload)

  return cardAuthClient.post(LOGIN_ENDPOINT, requestBody, {
    includeCsrf: false
  }).then((response) => {
    const result = unwrapResponse(response)

    if (result.code !== 200) {
      return Promise.reject(
        new Error(result.message || 'New service login failed')
      )
    }

    return {
      ...result,
      authToken: cardAuthClient.getAuthToken(),
      csrfToken: cardAuthClient.getCsrfToken(),
      cookieHeaderValue: cardAuthClient.buildCookieHeaderValue()
    }
  })
}

// 调用新服务退出接口，并携带签名与 CSRF 信息。
function logout() {
  return cardAuthClient.post(LOGOUT_ENDPOINT, {}, {
    includeCsrf: true
  }).then((response) => {
    const result = unwrapResponse(response)

    return {
      ...result,
      authToken: cardAuthClient.getAuthToken(),
      csrfToken: cardAuthClient.getCsrfToken(),
      cookieHeaderValue: cardAuthClient.buildCookieHeaderValue()
    }
  })
}

// 获取浏览器中当前保存的新服务认证 cookie。
function getAuthToken() {
  return cardAuthClient.getAuthToken()
}

// 获取浏览器中当前保存的新服务 CSRF cookie。
function getCsrfToken() {
  return cardAuthClient.getCsrfToken()
}

// 获取可供旧接口桥接使用的 Cookie 头字符串。
function getCookieHeaderValue() {
  return cardAuthClient.buildCookieHeaderValue()
}

// 判断当前浏览器中是否已经存在新服务登录态。
function hasAuthToken() {
  return !!getAuthToken()
}

const cardAuthService = {
  login,
  logout,
  getAuthToken,
  getCsrfToken,
  getCookieHeaderValue,
  hasAuthToken
}

export {
  DEFAULT_DEVICE_NAME,
  LOGIN_ENDPOINT,
  LOGOUT_ENDPOINT,
  buildLoginPayload,
  getAuthToken,
  getCookieHeaderValue,
  getCsrfToken,
  hasAuthToken,
  login,
  logout,
  unwrapResponse
}

export default cardAuthService
